var React = require('react');

function Tumblr (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.225 24C11.625 24 8.925 22.15 8.925 17.7V10.6H5.625V6.75C9.225 5.8 10.725 2.7 10.925 0H14.675V6.1H19.025V10.6H14.675V16.8C14.675 18.65 15.625 19.3 17.125 19.3H19.225V24H15.225Z","fill":"#001935"}));
}

Tumblr.defaultProps = {"width":"25","height":"24","viewBox":"0 0 25 24","fill":"none"};

module.exports = Tumblr;

Tumblr.default = Tumblr;
